export function validateHttpsUrl(url: string) {
  const regex = /https?:\/\/(www\.)?.*/gi;

  return regex.test(url);
}
